import { Controller } from 'stimulus';
import { useEventListener } from '@/js/util';

export default class extends Controller {
  static values = { groupId: String };

  initialize() {
    this.activeAttribute = `data-${this.identifier}-active`;
  }

  connect() {
    if (!this.groupIdValue) {
      throw new Error(`${this.identifier} should be initialized with a group-id!`);
    }

    useEventListener(this);
    this.addEventListener(document, this.#openedEventName, ({ target }) => {
      this.element.classList.toggle('!hidden', target !== this.element);
    });

    this.#notify(this.#active);
  }

  toggle() {
    this.#active = !this.#active;
  }

  close() {
    this.#active = false;
  }

  get #active() {
    return this.element.hasAttribute(this.activeAttribute);
  }

  set #active(value) {
    this.element.toggleAttribute(this.activeAttribute, value);
    this.#notify(value);
  }

  #notify(isActive) {
    if (isActive) {
      this.dispatch(`${this.groupIdValue}:open`);
    }
  }

  get #openedEventName() {
    return `${this.identifier}:${this.groupIdValue}:open`;
  }
}
